export default {
  name: 'MainPage',
  data () {
    return {
      src: this.$store.state.videoPath + 'ICT_Video_main.mp4'
    }
  }
}
